module.exports = __webpack_public_path__ + "img/temp_analytics.87e42a43.png";